import {
  CircularProgress,
  FormControl,
  FormLabel,
  InputAdornment,
  TextField,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { FaCheck, FaRegFileAlt, FaRegFileImage, FaTrash } from "react-icons/fa";
import { IoIosCloudUpload } from "react-icons/io";
import { useState } from "react";
import { deleteImage, uploadImage } from "../../../../../services/authApi";
import ErrorPopup from "../../../../common/particles.jsx/ErrorPopup";
// import {
//   deleteImage,
//   uploadImage,
// } from "../../../../services/uploadDeleteFileApi";
// import ErrorPopup from "../../../common/particles/ErrorPopup";

const AddRegisterPemilik = ({
  formik,
  isDetail,
  dataStatusEmail,
  isPendingStatusEmail,
}) => {
  const [errorMessage, setErrorMessage] = useState("");

  const handleClickPreview = (url) => {
    window.open(url, "_blank");
  };

  const { mutate: mutateUploadNPWP, isPending: isPendingUploadNPWP } =
    useMutation({
      mutationFn: uploadImage,
      onSuccess: (data) => {
        formik.setFieldValue("owner.files.npwp", data.url);
        formik.setFieldValue("owner.files.type_npwp", data.data_type);
      },
      onError: (err) =>
        setErrorMessage(err.message.id ? err.message.id : err.message),
    });

  const { mutate: mutateDeleteNPWP, isPending: isPendingDeleteNPWP } =
    useMutation({
      mutationFn: deleteImage,
      onSuccess: () => {
        formik.setFieldValue("owner.files.npwp", "");
        formik.setFieldValue("owner.files.type_npwp", "");
      },
      onError: (err) =>
        setErrorMessage(err.message.id ? err.message.id : err.message),
    });
  const { mutate: mutateUploadKTP, isPending: isPendingUploadKTP } =
    useMutation({
      mutationFn: uploadImage,
      onSuccess: (data) => {
        formik.setFieldValue("owner.files.ktp", data.url);
        formik.setFieldValue("owner.files.type_ktp", data.data_type);
      },
      onError: (err) =>
        setErrorMessage(err.message.id ? err.message.id : err.message),
    });

  const { mutate: mutateDeleteKTP, isPending: isPendingDeleteKTP } =
    useMutation({
      mutationFn: deleteImage,
      onSuccess: () => {
        formik.setFieldValue("owner.files.ktp", "");
        formik.setFieldValue("owner.files.type_ktp", "");
      },
      onError: (err) =>
        setErrorMessage(err.message.id ? err.message.id : err.message),
    });

  const SuccessfulUploadComponent = ({ title, value, type, fileType }) => {
    return (
      <div>
        <div className="w-full bg-blue-500 text-white py-3 px-4 rounded-t-lg flex items-center justify-between">
          <div className="flex items-center gap-2">
            <FaRegFileAlt className="text-[16px]" />
            <p>{title}</p>
          </div>
          {isDetail ? null : (
            <FaTrash
              className="text-red-500 hover:text-gray-300 cursor-pointer text-[14px]"
              onClick={() => {
                if (type === "ktp") mutateDeleteKTP({ value, fileType });
                if (type === "npwp") mutateDeleteNPWP({ value, fileType });
              }}
            />
          )}
        </div>
        <div
          className={`w-full border-dashed p-4 border-b-2 border-l-2 border-r-2 border-gray-300 rounded-b-lg bg-white ${
            value === ""
              ? "cursor-default"
              : "cursor-pointer hover:text-gray-300"
          } flex flex-col justify-center items-center`}
          onClick={() => {
            if (value !== "") handleClickPreview(value);
          }}
        >
          <>
            {(type === "ktp" && isPendingDeleteKTP) ||
            (type === "npwp" && isPendingDeleteNPWP) ? (
              <CircularProgress />
            ) : value === "" ? null : isDetail ? (
              <FaRegFileImage className="text-[64px] text-blue-500" />
            ) : (
              <FaCheck className="text-[64px] text-blue-500" />
            )}
            <p className="mt-2">
              {isPendingDeleteKTP || isPendingDeleteNPWP
                ? null
                : value === ""
                ? "Tidak ada berkas"
                : isDetail
                ? "Lihat Berkas"
                : "Berhasil Diupload!"}
            </p>
          </>
        </div>
      </div>
    );
  };

  return (
    <div>
      <FormControl fullWidth>
        <FormLabel>Nama Pemilik</FormLabel>
        <TextField
          fullWidth
          sx={{ marginBottom: 2 }}
          disabled={isDetail}
          value={formik.values.owner.name}
          onChange={(e) => formik.setFieldValue("owner.name", e.target.value)}
        />
      </FormControl>
      <FormControl fullWidth>
        <FormLabel>Nomor KTP Pemilik</FormLabel>
        <TextField
          fullWidth
          disabled={isDetail}
          sx={{ marginBottom: 2 }}
          value={formik.values.owner.id}
          onChange={(e) => {
            if (!isNaN(Number(e.target.value)) && e.target.value.length <= 16)
              formik.setFieldValue("owner.id", e.target.value);
          }}
        />
      </FormControl>
      <FormControl fullWidth>
        <FormLabel>No. Handphone</FormLabel>
        <TextField
          fullWidth
          sx={{ marginBottom: 2 }}
          disabled={isDetail}
          value={formik.values.owner.phone}
          onChange={(e) => formik.setFieldValue("owner.phone", e.target.value)}
          InputProps={{
            startAdornment: <InputAdornment>+62</InputAdornment>,
          }}
          error={
            formik.values.owner.phone.length > 0 &&
            formik.values.owner.phone[0] !== "8"
          }
          helperText={
            formik.values.owner.phone.length > 0 &&
            formik.values.owner.phone[0] !== "8"
              ? "No HP tidak valid"
              : null
          }
        />
      </FormControl>
      <FormControl fullWidth sx={{ marginBottom: 2 }}>
        <FormLabel>No NPWP Pemilik</FormLabel>
        <TextField
          fullWidth
          disabled={isDetail}
          sx={{ marginBottom: 2 }}
          value={formik.values.owner.npwp}
          onChange={(e) => {
            if (!isNaN(Number(e.target.value)) && e.target.value.length <= 15)
              formik.setFieldValue("owner.npwp", e.target.value);
          }}
        />
      </FormControl>
      <FormControl fullWidth>
        <FormLabel>Email</FormLabel>
        <TextField
          fullWidth
          disabled={isDetail}
          value={formik.values.owner.email}
          onChange={(e) => formik.setFieldValue("owner.email", e.target.value)}
          error={
            formik.values.owner.email.touched &&
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formik.values.owner.email)
          }
          helperText={
            formik.values.owner.email.touched &&
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formik.values.owner.email)
              ? "Email tidak valid"
              : ""
          }
        />
        {!isDetail ? (
          <div>
            {isPendingStatusEmail ? (
              <CircularProgress size={10} />
            ) : [4, 10, 11].includes(dataStatusEmail?.status_code) ? (
              <p>Email tersedia</p>
            ) : (
              <p className="text-red-500">
                {formik.values.owner.email === ""
                  ? "Email tidak boleh kosong"
                  : "Email sudah digunakan"}
              </p>
            )}
          </div>
        ) : null}
      </FormControl>

      <p className="text-[16px] my-2 font-semibold">Unggah File</p>
      {[
        {
          type: "ktp",
          value: formik.values.owner.files.ktp,
          file_type: formik.values.owner.files.type_ktp,
          key: "owner.files.ktp",
          title: "KTP",
          input_tag: "ktp-upload",
        },
        {
          type: "npwp",
          value: formik.values.owner.files.npwp,
          file_type: formik.values.owner.files.type_npwp,
          key: "owner.files.npwp",
          title: "NPWP",
          input_tag: "npwp-upload",
        },
      ].map((item) => {
        return (
          <div className="mb-4">
            {item.value === "" ? (
              <>
                <input
                  type="file"
                  disabled={isDetail}
                  id={item.input_tag}
                  hidden
                  accept="image/jpeg, image/png ,image/jpg, application/pdf"
                  onChange={(e) => {
                    formik.setFieldValue(item.key, "");
                    if (item.type === "ktp") mutateUploadKTP(e.target.files[0]);
                    if (item.type === "npwp")
                      mutateUploadNPWP(e.target.files[0]);
                  }}
                />
                <label for={item.input_tag} className="w-full">
                  <div className="w-full bg-blue-500 text-white py-3 px-4 rounded-t-lg flex items-center gap-2">
                    <FaRegFileAlt className="text-[16px]" />
                    <p>{item.title}</p>
                  </div>
                  <div className="w-full bg-white border-dashed p-4 border-b-2 border-l-2 border-r-2 border-gray-300 rounded-b-lg cursor-pointer hover:text-gray-300 flex flex-col justify-center items-center">
                    {(item.type === "ktp" && isPendingUploadKTP) ||
                    (item.type === "npwp" && isPendingUploadNPWP) ? (
                      <CircularProgress />
                    ) : (
                      <IoIosCloudUpload className="text-[64px] text-blue-500" />
                    )}
                    <p>Unggah {item.title}</p>
                  </div>
                </label>
              </>
            ) : (
              <div>
                <SuccessfulUploadComponent
                  title={item.title}
                  value={item.value}
                  type={item.type}
                  fileType={item.file_type}
                />
              </div>
            )}
          </div>
        );
      })}
      <ErrorPopup
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </div>
  );
};

export default AddRegisterPemilik;
